<div class="exhaust-setting-table" [ngStyle]="{ maxHeight: isExpanded ? '473px' : '210px' }">
    <div class="setting-header">
        <div class="header-text num-column">
            {{ 'exhaust-setting.header.num' | translate }}
        </div>
        <div class="header-text temp-column">
            {{ 'exhaust-setting.header.temp' | translate }}
        </div>
        <div class="header-text deviation-column">
            {{ 'exhaust-setting.header.deviation' | translate }}
        </div>
        <div class="header-text empty-column"></div>
    </div>
    <div class="setting-rows" #settingChannels>
        <ng-container *ngIf="settingIsEmpty()">
            <div class="empty-settings-text">
                {{ 'exhaust-setting.no-channels' | translate }}
            </div>
        </ng-container>
        <app-exhaust-setting-row
            *ngFor="let settingChannel of setting.settingChannels; index as i"
            [setting]="settingChannel"
            [vesselId]="setting.vesselId"
            [settingChannels]="settingChannels"
            [isAddSettingDisabled]="isAddSettingDisabled()"
            (onDuplicateRow)="duplicateRow($event)"
            (onDeleteRow)="deleteRow($event)"
            (onRowUpdated)="rowUpdated($event)">
        </app-exhaust-setting-row>
    </div>
    <div class="setting-footer">
        <div class="setting-footer-row">
            <div
                class="footer-button"
                data-cy="exh-gas-setting-add-cylinder-button"
                (click)="addSetting()"
                [class.disabled]="isAddSettingDisabled()">
                {{ 'exhaust-setting.footer.add' | translate }}
            </div>
            <div class="footer-slots">
                {{ 'exhaust-setting.footer.slots' | translate: { num: setting.settingChannels?.length || 0 } }}
            </div>
        </div>
        <div (click)="expandSetting()" class="footer-button" [class.disabled]="isExpandDisabled">
            {{
                isExpanded
                    ? ('exhaust-setting.footer.collapse' | translate)
                    : ('exhaust-setting.footer.expand' | translate)
            }}
        </div>
    </div>
</div>
